export const questionMixin = {
	methods: {
		onSort({relatedIndex}) {
			this.$emit('changeSort', {targetIndex: this.questionIndex, relatedIndex})
		},
	}
}

export default questionMixin;